export const USER_ROLES = {
    DEVELOPER: 'CucumberAdminUser',
    ADMIN: 'CucumberAdminUser',
    REPORT_USER: 'ReportUser'
}
